// extracted by mini-css-extract-plugin
export default {"grid":"coachFinishedSessionsPage_grid__OFmQ3","wrapper":"coachFinishedSessionsPage_wrapper__f0P8L","monthTitle":"coachFinishedSessionsPage_monthTitle__5DFs3"};